const UI_URL = process.env.VUE_APP_AUTH_BASE_URL;
const BASE_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  getServerHost() {
    return BASE_URL;
  },

  getAuthBaseUrl() {
    return UI_URL;
  },

  getLoginLink() {
    return `${this.getAuthBaseUrl()}/login`;
  },
};
